<div [ngClass]="{ 'text-primary__200': isPrimaryLightColor}">
  <app-button
    [disabled]="isDisabled"
    [color]="isPrimaryLightColor ? undefined : 'secondary'"
    [theme]="theme"
    [size]="size"
    (click)="onFilterButtonClicked()"
  >
    <span class="text-nowrap h6" [ngClass]="{ 'text-primary__200': isPrimaryLightColor,'text-primary': !isPrimaryLightColor}">
      <app-icon name="bold-search" class="align-middle" size="xs"></app-icon>
      {{ 'Buttons.Filter' | translate }}
    </span>
  </app-button>
</div>
